export default __webpack_public_path__ + "static/media/plugin-alpha-step2.df3623af.jpg";